import { render, staticRenderFns } from "./sopDialog.vue?vue&type=template&id=fb58b512&"
import script from "./sopDialog.vue?vue&type=script&lang=js&"
export * from "./sopDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb58b512')) {
      api.createRecord('fb58b512', component.options)
    } else {
      api.reload('fb58b512', component.options)
    }
    module.hot.accept("./sopDialog.vue?vue&type=template&id=fb58b512&", function () {
      api.rerender('fb58b512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/sopDialog.vue"
export default component.exports